import React from 'react';
import Tab from '../../../components/tabs/tab';
import TabsContainer from '../../../components/tabs';
import { Box } from '@material-ui/core';

import {
  MalmoStadHLogotypeIcon,
  SthlmStadLogotypeIcon,
  KBLogotypeIcon,
  KulturradetLogotypeIcon,
  NBLogotypeTextIcon,
} from '../../../components/icons';

const Logos = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box pt={5} pb={5}>
        <MalmoStadHLogotypeIcon scale={0.15} color={'#000'} />
      </Box>
      <Box pt={5}>
        <SthlmStadLogotypeIcon scale={0.27} color={'#000'} />
      </Box>
      <Box>
        <KBLogotypeIcon scale={1} color={'#000'} />
      </Box>
      <Box pb={5}>
        <KulturradetLogotypeIcon scale={0.325} color={'#000'} />
      </Box>
      <Box pt={5} pb={5}>
        <NBLogotypeTextIcon scale={1.7} color={'#000'} />
      </Box>
    </Box>
  );
};
const About = () => {
  const AboutEn = React.lazy(() => import(`./en`));
  const AboutNo = React.lazy(() => import(`./no`));
  const AboutSv = React.lazy(() => import(`./sv`));

  const FaqEn = React.lazy(() => import(`../faq/en`));
  const FaqNo = React.lazy(() => import(`../faq/no`));
  const FaqSv = React.lazy(() => import(`../faq/sv`));

  return (
    <TabsContainer>
      <Tab route={`no`} title={'norsk'} label="native.norwegian">
        <AboutNo />
        <FaqNo />
        <Logos />
      </Tab>
      <Tab route={`sv`} title={'svenska'} label="native.swedish">
        <AboutSv />
        <FaqSv />
        <Logos />
      </Tab>
      <Tab route={`en`} title={'engelska'} label="native.english">
        <AboutEn />
        <FaqEn />
        <Logos />
      </Tab>
    </TabsContainer>
  );
};

export default About;
